module.exports = __webpack_public_path__ + "media/site_templates/www.rubbishremoval.company/images/splash-1a76685422a0bb2ed69882b992da75c6.jpg";